module.exports = __webpack_public_path__ + "img/ys2.0d519bea.jpg";